module.exports = __webpack_public_path__ + "img/bgAuth.d24a86fb.jpg";